<template>
  <div>
    <label class="control-label">
      {{ label }}<span v-if="isRequired" class="field__label_required">*</span>
    </label>
    <TransitionGroup
      class="list__wrapper_references vert-scroll"
      name="references-list"
      tag="div"
    >
      <div
        class="wrapper__input"
        v-for="item in list"
        :key="item"
        v-if="typeof list === 'object'"
      >
        <input
          class="form-control"
          type="text"
          :value="getDescription(item)"
          readonly
        />
        <input
          v-if="withCounts"
          class="form-control"
          type="number"
          v-model="item.count"
          min="1"
          max="1000"
          :disabled="!buttonsAreVisible"
        />
        <div class="wrapper__buttons">
          <div v-if="buttonsAreVisible">
            <button
              class="btn btn-default btn-icon"
              type="button"
              @click="deleteItem(item.id)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
          <div v-if="!withoutLinks">
            <button
              class="btn btn-default btn-icon"
              type="button"
              @click="goToAnotherForm(item)"
            >
              <i class="fa fa-link"></i>
            </button>
          </div>
        </div>
      </div>
    </TransitionGroup>
    <div v-if="list.length === 0" class="wrapper__text_unset">
      <span>Нет значений</span>
    </div>
    <div v-if="buttonsAreVisible" class="references-list__actions">
      <button
        class="btn d-inline-flex btn-default btn-icon"
        type="button"
        @click="$emit('on-plus-click')"
      >
        <i class="fa fa-plus"></i> Добавить
      </button>
      <button
        v-show="list.length > 0"
        class="btn d-inline-flex btn-default btn-icon"
        type="button"
        @click="deleteAllItems"
      >
        <i class="fa fa-eraser"></i>
        Удалить всё
      </button>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["on-plus-click", "on-delete", "on-delete", "on-change"],
  props: {
    itemDescriptionFields: {
      type: Array,
      default: ['name'],
    },
    label: {
      type: String,
      required: true,
    },
    list: {
      type: Array | String,
      default() {
        return [];
      },
    },
    slug: {
      type: String,
      default: "products",
    },
    withoutLinks: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    buttonsAreVisible: {
      type: Boolean,
      default: false,
    },
    noticeField: {
      type: String,
      default: null,
    },
    withCounts: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goToAnotherForm(item) {
      const { id } = item;
      const url = `/${this.slug}/${id}`;
      const routeData = this.$router.resolve(url);
      window.open(routeData.href, "_blank");
    },
    getDescription(item) {
      let description = [];
      this.itemDescriptionFields.forEach((fieldName) => {
        description.push(item[fieldName]);
      });
      description = description.join(', ');
      if (this.noticeField) {
        description += ` (${item[this.noticeField]})`;
      }
      return description;
    },
    deleteAllItems() {
      this.$emit("on-delete", []);
    },
    deleteItem(id = 1) {
      const modifiedList = this.list.filter(
        (currentItem) => id !== currentItem.id
      );
      this.$emit("on-delete", modifiedList);
    },
  },
};
</script>

<style scoped>
.list__wrapper_references .wrapper__input {
  display: grid;
  grid-template-columns: auto 4em auto;
  column-gap: 0.5em;
}

.list__wrapper_references .wrapper__input:not(:last-child) {
  margin-bottom: 1.2em;
}

.references-list__actions .actions__action_delete-all,
.list__wrapper_references > div {
  animation: horizontal-appear 0.3s ease;
}

.wrapper__text_unset {
  margin: 0.5em 0 0.8em 0;
}

.list__wrapper_references {
  transition: all 0.3s;
  padding-right: 1em;
  max-height: 14em;
  overflow-y: auto;
  overflow-x: hidden;
}

.list__wrapper_references:not(:empty) {
  margin-bottom: 1em;
}

.references-list-leave-to {
  opacity: 0;
}

.references-list-leave-active {
  transition: all 0.3s ease;
}
.references-list-leave-to {
  transform: translateX(80px);
}

.list__wrapper_references .wrapper__buttons {
  display: inline-flex;
  flex-direction: row;
}

.list__wrapper_references .wrapper__buttons > div:first-child {
  margin-right: 0.5em;
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/ui/ReferencesList.vue